import theme from '@styles/theme';
export default {
  section: {
    width: '100%',
    backgroundColor: theme.rawColors.neutralWhite,
    padding: ['0 16px',
    // mobile
    '0 24px',
    // mobilelg
    '0 40px',
    // tablet
    '0 40px',
    // tabletlg
    '0 40px',
    // desktop
    '0 56px' // widescreen
    ]
  },
  sectionHeader: {
    position: 'relative',
    width: '100%',
    backgroundColor: theme.rawColors.neutralWhite,
    padding: '0 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  container: {
    maxWidth: '1920px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  header: {
    textAlign: 'center',
    maxWidth: ['100%', '100%', '80%', '70%', '60%', '55%'],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: ['32px', '40px', '34px', '43px', '48px', '64px']
  },
  headerImage: {
    position: 'relative',
    maxWidth: ['240px', '240px', '240px', '260px', '292px', '390px'],
    width: '100%',
    aspectRatio: '390 / 120',
    marginBottom: ['24px', '24px', '20px', '25px', '29px', '40px']
  },
  title: {
    fontFamily: theme.fonts.noe,
    fontWeight: theme.fontWeights.bold,
    textTransform: 'uppercase',
    letterSpacing: theme.letterSpacings.mediumCaps,
    color: theme.rawColors.brown,
    marginBottom: ['16px', '18px', '20px', '24px', '28px', '32px'],
    fontSize: ['36px', 'clamp(42px, calc(19px + 4.79vw), 88px)'],
    lineHeight: '110%'
  },
  description: {
    maxWidth: ['295px', '608px', '772px', '772px', '866px', '866px'],
    textAlign: 'center',
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    color: theme.rawColors.brown,
    lineHeight: '140%',
    letterSpacing: ['1.4px', '1.4px', '1.4px', '1.4px', '1.6px', '1.6px'],
    fontSize: ['14px', '14px', '14px', '14px', '16px', '16px']
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: ['1px', '16px 10px', '16px 10px', '16px 10px', '16px 12px', '16px'],
    justifyContent: 'center'
  },
  tileWrapper: {
    width: ['50%',
    // mobile - 2 cols, max width
    '20%',
    // mobilelg
    '15%',
    // tablet
    '12%',
    // tabletlg
    '10%',
    // desktop
    '9%' // widescreen
    ],
    maxWidth: ['171px', '123px', '123px', '123px', '139px', '165.2px'],
    minWidth: ['123px', '123px', '123px', '123px', '123px', '139px']
  },
  tile: {
    width: ['100%', '100%', '100%', '100%', '100%', '100%'],
    aspectRatio: '1 / 1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'none',
    position: 'relative',
    overflow: 'hidden',
    padding: ['24px', '12px', '12px', '12px', '12px', '12px'],
    backgroundColor: 'transparent',
    transition: 'transform 0.3s ease',
    '&:hover span': {
      borderBottom: `1px solid ${theme.rawColors.darkGrey600}`
    }
  },
  tileImage: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    aspectRatio: '1 / 1',
    flexShrink: 0,
    '& img': {
      position: 'relative',
      objectFit: 'contain'
    }
  },
  tileLabel: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    textTransform: 'uppercase',
    letterSpacing: ['1.1px', '1.1px', '1.1px', '1.1px', '1.3px', '1.3px'],
    color: theme.rawColors.darkGrey600,
    textAlign: 'center',
    fontSize: ['11px', '11px', '11px', '11px', '13px', '13px'],
    lineHeight: '140%',
    position: 'relative',
    zIndex: 1,
    borderBottom: '1px solid transparent',
    textDecoration: 'none',
    transition: 'text-decoration 0.2s ease',
    display: 'inline-block',
    width: 'fit-content',
    maxWidth: '100%',
    alignSelf: 'center',
    wordBreak: 'break-word'
  }
};